{
  "02ac94b779729e39": "Update the details below with your workplace’s current rules or any information you want professionals to know. Those who are new to your workplace will read these before their first shift if you toggle the quiz on. ",
  "06cf0ff4df1ac1c6": "Question {{questionIndex}}",
  "080ca4399b72fa20": "Review current quiz",
  "0997e8464b3e90bc": "Quiz is ready. Review it to make sure it covers your rules.",
  "0eaa40f12dbd8f88": "Successfully updated rules.",
  "1509f561f2416598": "Save",
  "155f816c0407310c": "Submit",
  "19766ed6ccb2f4a3": "Cancel",
  "322380c1273e3abd": "You have unsaved changes. Are you sure you want to leave?",
  "3a83868ee622f159": "Flag an issue",
  "3b0a293c2fc1c76c": "Keep Your Quiz Up to Date",
  "3f4662b6e471359c": "Successfully updated rules. Please wait as we generate your new quiz!",
  "4bd1e71db44f8e19": "Professionals who are new to your workplace will take this quiz before their first shift. Review the quiz to ensure that it covers your workplace's rules. If there are any changes you'd like to make to the quiz, edit your rules below.",
  "536fbcf0eb525e3e": "Answer Options",
  "54de7f6007056e6f": "Question:",
  "5da69270e5973c17": "Generate Quiz",
  "62035cce0bd17f2f": "Most workplaces have this turned on.",
  "64f89cf423ee1a16": "Answer:",
  "82991cd57053196f": "Share Rules and Expectations",
  "82eaf2cc44a413e8": "Quiz could not be generated from the current rules. Adjust your notes and try again.",
  "9a39b66545015463": "Save updates",
  "9b6056e6e1d22e07": "Error generating quiz. Please, try again or contact support.",
  "9ee56e90fa3bd1f1": "Your changes have been saved. {{wrongNotesLengthMessage}}",
  "a26a1554115d743f": "Share your workplace’s rules below and then toggle the quiz on to require professionals who are new to your workplace to read and take a brief quiz on these rules.",
  "a39ae68e40a3a207": "Please share details on the problem below and a member of our team will address the problem and get back to you within 1 business day. To turn quizzes off, adjust the toggle under “Quiz Requirement”.",
  "aae3d09135e30194": "Quiz failed to generate. Please try again or contact support.",
  "b36f1afa14454c1c": "Learn More.",
  "b8a8b25930316a9f": "Thank you for flagging an issue with your quiz",
  "cba9177d5d326157": "Professionals who are new to your workplace will take this quiz before their first shift if you toggle the quiz on. Review the quiz to ensure that it covers your workplace's rules. If there are any changes you'd like to make to the quiz, edit your rules below.",
  "d52baa251ff3a231": "Quiz is active",
  "de8bfc6eb3a0e5e1": "Update the details below with your workplace’s current rules or any information you want professionals to know. Those who are new to your workplace will read these before their first shift. ",
  "e3c8c9b2fc87dc21": "Workplace Rules Quiz",
  "e46a04e59f962c73": "Here's an example of a question from your workplace's quiz:",
  "e634b1a44f1f9a05": "Quiz is not active",
  "eadcb509d415d4c8": "Your permission level does not allow you to edit the information on this page. If you want to edit this page you may ask your administrator to update your role in the platform.",
  "eb04339b6ede32d6": "Generating quiz",
  "ec4235ff36167cb0": "Workplace Quiz",
  "fb019d338b4305ef": "Correct answer",
  "fd31b864096d4fc3": "May take up to a minute"
}
